import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { BrowserRouter } from "react-router-dom";
import React, { useState, useEffect, createContext } from "react";

import App from "../App";
import config from "../config.json";
import ThemeProvider from "../theme";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
	const app = initializeApp({
		apiKey: config.apiKey,
		authDomain: config.authDomain,
		projectId: config.projectId,
		storageBucket: config.storageBucket,
		messagingSenderId: config.messagingSenderId,
		appId: config.appId,
	});

	const [currentUser, setCurrentUser] = useState(null);
	const [loading, setLoading] = useState(true);
	const [idToken, setIdToken] = useState("");
	// const addUserClaim = firebase.functions().httpsCallable("addUserClaim");

	const signOut = async () => {};

	useEffect(() => {
		const unsubscribe = getAuth().onAuthStateChanged(async (user) => {
			setLoading(false);
			setCurrentUser(user);
			if (user) {
				// getAuth().addUserClaim()
				// addUserClaim({ email: user.email });
				const token = await user.getIdToken();
				setIdToken(token);
			}
		});

		return () => {
			unsubscribe();
		};
	}, []);

	return (
		<AuthContext.Provider
			value={{
				loading,
				signOut,
				currentUser,
			}}
		>
			<BrowserRouter>
				<ThemeProvider>
					{children}
					<App />
				</ThemeProvider>
			</BrowserRouter>
		</AuthContext.Provider>
		// <>
		// 	{/* {loading && <div>Loading...</div>}
		// 	{currentUser && ( */}

		// 	{/* )} */}
		// </>
	);
};
